import { Col, Row, Skeleton } from 'antd';
import styles from './index.module.less';
import { HomeArticleModel } from '@/types/home';
import { useRouter } from 'next/router';
import { getPathTitle, getTypeColor, imgUrl } from '@/shared/utils';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import dayjs from 'dayjs';

const HomeFullItem = ({
  articleModel,
  showBottomLine = true,
  showPadding = true,
}: {
  articleModel?: HomeArticleModel;
  showBottomLine?: Boolean;
  showPadding?: Boolean;
}) => {
  const router = useRouter();
  const { width } = useScreenSize();

  const titleStyle = () => {
    if (width >= 576) {
      return classNames(styles.titleContainer, styles.pcTitleContainer);
    }
    return classNames(styles.titleContainer, styles.mobileTitleContainer);
  };

  const onClick = () => {
    if (articleModel?.article_id != undefined) {
      router.push(`/article/${articleModel?.title_id}`)
      // router.push(
      //   `/article/${articleModel?.article_id}/${articleModel?.type}/${getPathTitle(
      //     articleModel?.title,
      //   )}`,
      // );
    }
  };

  return (
    <>
      <Row
        className={styles.mainContainer}
        style={{
          borderBottom: showBottomLine ? '1px solid var(--app-line-bg-rgb)' : undefined,
          cursor: 'pointer',
          padding: showPadding ? '24px' : '24px 0',
        }}
        onClick={onClick}
      >
        <Col
          span={
            articleModel?.disaster_type ||
              (articleModel != null && articleModel?.cover_image === null)
              ? 24
              : 14
          }
          style={{ paddingRight: '1rem' }}
        >
          {articleModel == null ? (
            <Skeleton active />
          ) : (
            <>
              <Link
                href={`/article/${articleModel?.title_id}`}
              // href={`/article/${articleModel?.article_id}/${articleModel?.type}/${getPathTitle(
              //   articleModel?.title,
              // )}`}
              >
                <div className={titleStyle()}>{articleModel?.title}</div>
              </Link>

              {width >= 768 && <p className={styles.descContainer}>{articleModel?.description}</p>}

              {articleModel?.disaster_type && (
                <Link
                  // href={`/crisis-database?type=${articleModel?.type}&disaster_type=${articleModel?.disaster_type}`}
                  href={`/${getPathTitle(articleModel?.type)}/${getPathTitle(articleModel?.disaster_type)}`}
                  onClick={(e) => {
                    e?.stopPropagation();
                  }}
                >
                  <span
                    className={styles.disasterType}
                    style={getTypeColor(articleModel?.disaster_type)}
                  >
                    {articleModel?.disaster_type}
                  </span>
                </Link>
              )}

              <div className={styles.timeContainer}>
                {dayjs(articleModel?.create_time).format('YYYY-MM')}
              </div>
            </>
          )}
        </Col>

        {!articleModel?.disaster_type && (
          <Col span={articleModel != null && articleModel?.cover_image === null ? 0 : 10}>
            {articleModel === null ? (
              <Skeleton.Image active />
            ) : (
              <>
                {articleModel?.cover_image && (
                  <Image
                    className={styles.imgContainer}
                    src={imgUrl(articleModel?.cover_image, 'mid')}
                    alt={articleModel.title}
                    loading="lazy"
                    width={296}
                    height={166}
                    layout="responsive"
                  />
                )}
              </>
            )}
          </Col>
        )}
      </Row>
    </>
  );
};

export default HomeFullItem;
